import Swiper from 'swiper';
import { Navigation, Pagination, Autoplay } from 'swiper/modules';

export function initArticleProductSlider(): void {
	const sliderElement = document.querySelector<HTMLElement>('.main-article-product-slider');

	if (!sliderElement) return;

	new Swiper(sliderElement, {
		modules: [Navigation, Pagination, Autoplay],
		slidesPerView: 1.4,
		pagination: {
			clickable: true,
			el: sliderElement.querySelector<HTMLElement>('.swiper-pagination'),
		},
		navigation: {
			prevEl: sliderElement.querySelector<HTMLElement>('.swiper-button-prev'),
			nextEl: sliderElement.querySelector<HTMLElement>('.swiper-button-next'),
		},
		breakpoints: {
			1024: {
				slidesPerView: 3,
			},
		},
	});
}

document.addEventListener('DOMContentLoaded', () => {
	initArticleProductSlider();
});